<script lang="ts" setup>
import { injectMandatory } from "@/vf"
import type { ListState } from "@/vf/components/crud/list/types"

const listState = injectMandatory<ListState>(
    "list-state",
    "VfListSearch must be used inside an element that provides list-state like VfList.",
)
</script>

<template>
    <button
        type="button"
        class="btn btn-primary btn-shape-rounded btn-shape-rounded-white"
        @click="listState.filter = {}"
    >
        <i class="fas fa-xmark"></i>
    </button>
</template>
